module.exports = __webpack_public_path__ + "img/icon_expand.01503fbf.png";